import { render, staticRenderFns } from "./ModalSuporteSecretaria.vue?vue&type=template&id=92a2b5c4&scoped=true"
import script from "./ModalSuporteSecretaria.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteSecretaria.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteSecretaria.vue?vue&type=style&index=0&id=92a2b5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a2b5c4",
  null
  
)

export default component.exports